import useMutationFlooringCreateUpdate from './flooring-use-mutation-create-update';
import useMutationFlooringDelete from "./flooring-use-mutation-delete";
import useMutationFlooringVariationCreateUpdate from "./flooring-variation-use-mutation-create-update";
import useMutationFlooringVariationDelete from "./flooring-variation-use-mutation-delete";


export const flooringUseMutation = {
  createUpdate: useMutationFlooringCreateUpdate,
  delete: useMutationFlooringDelete,
  variationCreateUpdate: useMutationFlooringVariationCreateUpdate,
  variationDelete: useMutationFlooringVariationDelete,
};
